<template>
  <!-- 开启网上服务 -->
  <div class="page-container" id="onlineServiceContainer">
    <el-form :model="onlineServiceForm" ref="ruleFormRef" class="form-panel" label-position="top"
             :validateOnRuleChange="false">
      <el-row class="content-panel top-radius">
      <!--   <el-col :span="24"> -->
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="结算公司">
                <el-associate style="width: 100%;"
                              :columns="associate_columns_csOffice"
                              :query-method="associate_queryMethod_csOffice"
                              class="input_length"
                              clearable
                              :query-length="0"
                              :default-first-option="true"
                              label-prop="corpNameCn"
                              value-prop="corpNameCn"
                              placeholder=""
                              @change=onChangeCorpName
                              v-model="onlineServiceForm.corpNameCn"
                              size="mini"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="客户名称">
                <el-associate style="width: 100%;"
                              :columns="associate_columns_csCustCm"
                              :query-method="associate_queryMethod_csCustCm"
                              class="input_length"
                              clearable
                              :query-length="0"
                              :default-first-option="true"
                              label-prop="custNameCn"
                              value-prop="custNameCn"
                              case="upper"
                              placeholder=""
                              v-model="onlineServiceForm.custNameCn"
                              size="mini"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否有效">
                <el-select class="length_input" size="mini" v-model="onlineServiceForm.isActive" clearable
                           placeholder="请选择">
                  <el-option
                      v-for="item in isValidList"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <label slot="label" class="label_no"></label>
                <el-button class="el-button-search" type="primary" size="small" plain @click="handleQuery"  >查询</el-button>
                <el-button type="primary" size="small" plain @click="handleReset"  >重置</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-button type="primary" size="small" plain @click="handleAdd" >新增</el-button>
              <el-button type="primary" size="small" plain @click="handleEnable" >启用</el-button>
              <el-button type="danger" size="small" plain @click="handleDisable" >禁用</el-button>
              <el-button type="danger" size="small" plain @click="handleDel" >删除</el-button>
            </el-col>
          </el-row>
     </el-row>
      <el-row class="table-panel top-radius">
          <!-- 表格-start -->
          <el-row style="margin-top: 15px">
            <hot-table ref="onlineServiceTableRef" :data-source="onlineServiceTableDataSource"
                       :settings="onlineServiceTableSettings" col-settings-key="onlineService">
              <hot-column :has-tip="true" data="corpNameCn" title="结算公司" width="150">
              </hot-column>
              <hot-column :has-tip="true" data="custNameCn" title="委托单位" width="150">
              </hot-column>
              <hot-column :has-tip="true" data="isActive" title="是否有效" className="htCenter" readOnly="true" width="150"
                          type="checkbox" :checked-template="1" :unchecked-template="0">
              </hot-column>
              <!-- <hot-column :has-tip="true" data="" title="角色名称" width="150"> -->
              <!-- </hot-column> -->
              <hot-column :has-tip="true" data="creatorName" title="创建人" width="150">
              </hot-column>
              <hot-column :has-tip="true" data="createTime" date-format="YYYY-MM-DD HH:mm:ss" title="创建时间" width="150">
              </hot-column>
            </hot-table>
          </el-row>
       <!--  </el-col> -->
        <!-- 分页start -->
        <div class="pg_div">
          <el-pagination :current-page="pageConfig.currentPage" :layout="pageConfig.layout"
                         :page-size="pageConfig.pageSize" :page-sizes="pageConfig.pageSizes" :total="pageConfig.total"
                         @current-change="handleCurrentChange" @size-change="handleSizeChange"/>
        </div>
        <!-- 分页end -->
      </el-row>
    </el-form>
    <!--开启网上服务弹出框-->
    <el-dialog
        :visible.sync="openOnlineServiceDialogVisible"
        title="开启网上服务"
        :append-to-body="true"
        :close-on-click-modal="true"
        width="70%"
    >
      <el-dialog
          width="30%"
          title="创建账号"
          height="80%"
          v-if="adminAccountDialogVisible"
          :visible.sync="adminAccountDialogVisible"
          @close="handleClose"
          append-to-body>
        <el-form v-model="adminAccountDialogForm">
          <el-row :gutter="22">
            <el-col >
              <el-form-item label="管理员账号" class="redItem">
                  <el-input size="mini" v-model="adminAccountDialogForm.start" disabled style="width: 25%"></el-input>
                  <el-input size="mini" v-model="adminAccountDialogForm.end" clearable style="width: 75%"  @blur="onChangeUserName" id="userName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col>
              <el-form-item label="结算公司">
                <el-associate style="width: 100%;"
                              :columns="associate_columns_csOffice"
                              :query-method="associate_queryMethod_csOffice"
                              class="input_length"
                              clearable
                              disabled
                              :query-length="0"
                              :default-first-option="true"
                              label-prop="corpNameCn"
                              value-prop="corpNameCn"
                              placeholder=""
                              v-model="adminAccountDialogForm.corpNameCn"
                              @change="onChangeSysCorp"
                              size="mini"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col>
              <el-form-item label="角色">
                <el-associate style="width: 100%;"
                              :columns="associate_columns_sysRole"
                              :query-method="associate_queryMethod_sysRole"
                              class="input_length"
                              clearable
                              :query-length="0"
                              :default-first-option="true"
                              label-prop="roleName"
                              value-prop="roleName"
                              placeholder=""
                              multiple="true"
                              v-model="adminAccountDialogForm.roleNames"
                              :title="adminAccountDialogForm.roleNames"
                              @change="onChangeSysRole"
                              :disabled="roleEditabled"
                              size="mini"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" style="margin-top: 50px">
            <label slot="label" class="label_no"></label>
            <el-col align="middle">
              <el-button type="primary" size="small" plain :loading="isOpenService" @click="adminAccountDialogConfirm" >确认</el-button>
              <el-button type="primary" size="small" plain @click="cancelOpenService" >取消</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
      <div style="height: 450px">
        <el-form v-model="openOnlineServiceDialogForm" :rules="onlineServiceRules" >
          <el-row :gutter="10">
            <el-col :span="7" style="margin-top: 3px">
              <el-form-item label="客户名称" prop="data">
                <el-input
                    size="small"
                    placeholder="请输入全称或者简称进行查询"
                    case="upper"
                    clearable
                    v-model="openOnlineServiceDialogForm.data"
                ></el-input>


              </el-form-item>
            </el-col>
<el-col :span="7">
              <el-form-item label="结算公司" prop="corpNameCn">
                <el-associate style="width: 100%;"
                              :columns="associate_columns_csOffice"
                              :query-method="associate_queryMethod_csOffice"
                              class="input_length"
                              clearable
                              case="upper"
                              :query-length="0"
                              :default-first-option="true"
                              label-prop="corpNameCn"
                              value-prop="sysCorpId"
                              placeholder="结算公司不能为空"
                              v-model="openOnlineServiceDialogForm.corpNameCn"
                              :title="openOnlineServiceDialogForm.corpNameCn"
                              size="mini"
                              @change="corpNameCnChange"
                />
              </el-form-item>
            </el-col>


            <el-col :span="6" style="margin-top: 14px">
              <el-form-item >
                <el-button type="primary" size="small" plain @click="handleQueryDialog"  >查询</el-button>
                <el-button type="primary" size="small" plain @click="handleResetDialog" >重置</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- table start -->
        <el-row style="margin-top: 15px;margin-bottom: 20px;height: 300px">
          <hot-table
              ref="onlineServiceDialogTableRef"
              :data-source="onlineServiceDialogTableDataSource"
              col-settings-key="onlineServiceDialogTable"
          >
            <hot-column :has-tip="true" data="custAlias" title="公司简称" width="150"></hot-column>
            <hot-column :has-tip="true" data="custNameCn" title="中文全称" width="300"></hot-column>
            <hot-column :has-tip="true" data="custNameEn" title="英文全称" width="300"></hot-column>
          </hot-table>
          <!-- 分页start -->
          <div class="pg_div">
            <el-pagination
                :current-page="pageConfigDialog.currentPage"
                :layout="pageConfigDialog.layout"
                :page-size="pageConfigDialog.pageSize"
                :page-sizes="pageConfigDialog.pageSizes"
                :pager-count="pageConfigDialog.count"
                :total="pageConfigDialog.total"
                @current-change="handleCurrentChangeDialog"
                @size-change="handleSizeChangeDialog"
            />
          </div>
          <!-- 分页end -->
        </el-row>
        <!-- table end -->
        <el-row type="flex" justify="center" style="margin-top: 50px">
          <label slot="label" class="label_no"></label>
          <el-col :span="6">
            <div></div>
            <el-button type="primary" size="small" plain @click="handleEnableDialog">开启</el-button>
            <el-button type="primary" size="small" plain @click="handleCancel">取消</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getSecondRole, queryCarrierInfo, queryCsCustInfo, querySysCorpInfo,queryVwCsCustInfo} from "@/api/commonService";
import { deleteWebService, getSysCorpCustDataSource, OffWebService, onWebService, startWebService, getCsCustType,checkSysUserName } from "@/api/system";

export default {
  data() {
    return {
      associate_columns_csOffice: [
        {
          title: "代码",
          field: 'corpCode'
        },
        {
          title: "公司简称",
          field: 'corpName'
        },
        {
          title: "中文全称",
          field: 'corpNameCn'
        }
      ],
      associate_columns_sysRole: [
        {
          title: "角色代码",
          field: 'roleCode'
        },
        {
          title: "角色名称",
          field: 'roleName'
        },
      ],
      associate_columns_csCustCm: [
        {
          title: "中文简称",
          field: 'custAlias'
        },
        {
          title: "中文全称",
          field: 'custNameCn'
        },
        {
          title: "助记码",
          field: 'mnemonicCode'
        }
      ],
      onlineServiceForm: {},
      openOnlineServiceDialogForm: {
        data: ""
      },
      onlineServiceDialogTableDataSource: [],
      adminAccountDialogForm: { start: 'ADMIN_',corpNameCn: null ,sysRoleIdAndNames: [], sysRoleIds: [], roleNames: [], corpNameEn: null},
      // 分页
      pageConfig: {
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        pageSize: 100,
        pagerCount: 10,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100]
      },
      // 分页
      pageConfigDialog: {
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        pageSize: 100,
        pagerCount: 10,
        count: 5,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100]
      },
      // 表格校验
      onlineServiceRules: {
      corpNameCn: [{
                    required: true,
                    message: "不能为空",
                    trigger: ['blur', 'change']
                 }]
                 },
      // 表格数据
      onlineServiceTableDataSource: [],
      // 表格设置
      onlineServiceTableSettings: {
        height: 100,
        stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig

      },
      isValidList: [
        {
          key: 1,
          value: '是'
        },
        {
          key: 0,
          value: '否'
        }
      ],
      isOpenService: false,
      openOnlineServiceDialogVisible: false,
      adminAccountDialogVisible: false,
      roleEditabled: false
    };
  },
  async created() {

  },
  mounted() {
    this.onlineServiceTableSettings.height = document.body.clientHeight -(220);
  },
  methods: {
    handleClose(){
      this.adminAccountDialogForm = { start: 'ADMIN_',corpNameCn: null }
    },
    // 结算公司
    associate_queryMethod_csOffice({ keyword, pageSize, currentPage }) {
      let params = {}
      if (keyword === '') {
        params = {
          isDeleted3: "0"
        }
      } else {
        params = {
          corpCode0: "%" + keyword + "%",
          corpName1: "%" + keyword + "%",
          corpNameCn2: "%" + keyword + "%",
          isDeleted3: "0"
        }
      }

      let data =
          {
            action: "query",
            crudType: "SELECT",
            sorting: ["CTS_ILPSysCorp.corpNameCn"],
            mainModelName: "CTS_ILPSysCorp",
            tag: "CTS_ILP_es",
            where: "(((CTS_ILPSysCorp.corpCode LIKE :corpCode0 OR CTS_ILPSysCorp.corpName LIKE :corpName1) OR CTS_ILPSysCorp.corpNameCn LIKE :corpNameCn2) AND CTS_ILPSysCorp.isDeleted = :isDeleted3)",
            currentPage: currentPage,
            pageSize: pageSize,
            returnPage: true,
            returnTotal: false,
            reqArgs: params,
            fields: ["CTS_ILPSysCorp.corpCode", "CTS_ILPSysCorp.sysCorpId", "CTS_ILPSysCorp.corpName", "CTS_ILPSysCorp.corpNameCn", "CTS_ILPSysCorp.corpNameEn"],
            enableCascade: true
          }
      return new Promise(resolve => {
        querySysCorpInfo(data).then(res => {
          console.log("querySysCorpInfo", res)
          resolve({
            records: res.data.data,
            total: res.data.totalRecord
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    associate_queryMethod_sysRole({ keyword, pageSize, currentPage }){
      let params = {}
      if (keyword === '') {
        params = {
          page: currentPage,
          pageSize: pageSize || 10
        }
      } else {
        params = {
          roleName: "%" + keyword + "%",
          page: currentPage,
          pageSize: pageSize || 10
        }
      }

      return new Promise(resolve => {
        getSecondRole(params).then(res => {
          console.log("getSecondRole", res)
          resolve({
            records: res.sysRoles,
            total: res.recordNum
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    associate_queryMethod_csCustCm({ keyword, pageSize, currentPage }) {

    var settleOffice= this.onlineServiceForm.sysCorpId;
      let params = {}
      if (keyword === '') {
       if(settleOffice){
        params = {
          isDeleted6: "0",
          custType4: "%CM%",
          custType5: "%OA%",
          settleOffice7:settleOffice
        }
        }else{
         params = {
           isDeleted6: "0",
           custType4: "%CM%",
           custType5: "%OA%"
          }
        }
      } else {
      if(settleOffice){
        params = {
                custAlias0: "%" + keyword + "%",
                custNameCn1: "%" + keyword + "%",
                mnemonicCode2: "%" + keyword + "%",
                isDeleted6: "0",
                custType5: "%OA%",
                custType4: "%CM%",
                settleOffice7:settleOffice
              }
      }else{
      params = {
               custAlias0: "%" + keyword + "%",
               custNameCn1: "%" + keyword + "%",
               mnemonicCode2: "%" + keyword + "%",
               isDeleted6: "0",
               custType5: "%OA%",
               custType4: "%CM%"
           }
      }

      }

      let data =
          {
            action: "query",
            crudType: "SELECT",
            sorting: ["CTS_ILPVwCsCust.custNameCn"],
            mainModelName: "CTS_ILPVwCsCust",
            tag: "CTS_WEB_es",
            where: "(((((CTS_ILPVwCsCust.custAlias LIKE :custAlias0 OR CTS_ILPVwCsCust.custNameCn LIKE :custNameCn1) ) AND (CTS_ILPVwCsCust.custType LIKE :custType4 OR CTS_ILPVwCsCust.custType LIKE :custType5)) ) AND CTS_ILPVwCsCust.isDeleted = :isDeleted6  AND CTS_ILPVwCsCust.settleOffice= :settleOffice7)",
            currentPage: currentPage,
            pageSize: pageSize,
            returnPage: true,
            returnTotal: false,
            reqArgs: params,
            fields: [
              "CTS_ILPVwCsCust.csCustId",
              "CTS_ILPVwCsCust.custAlias",
              "CTS_ILPVwCsCust.custNameCn",
              "CTS_ILPVwCsCust.custNameEn",
              "CTS_ILPVwCsCust.custType",
              "CTS_ILPVwCsCust.isActive",
              "CTS_ILPVwCsCust.isBlacklist",
              "CTS_ILPVwCsCust.isCustomer",
              "CTS_ILPVwCsCust.isDeleted",
              "CTS_ILPVwCsCust.isOneTimeCustomer",
              "CTS_ILPVwCsCust.isSettlement",
              "CTS_ILPVwCsCust.isSupplier",
              "CTS_ILPVwCsCust.mdmCustCode",
              "CTS_ILPVwCsCust.postCode"
            ],
            enableCascade: true
          }
      return new Promise(resolve => {
        queryVwCsCustInfo(data).then(res => {
          console.log("queryCsCustInfo", res)
          resolve({
            records: res.data.data,
            total: res.data.totalRecord
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    // 新增
    handleAdd() {
      this.openOnlineServiceDialogVisible = true
      this.pageConfigDialog.currentPage = 1;
      this.pageConfigDialog.pageSizes = 100;
      this.pageConfigDialog.total = 0;
    },
    // 启用
    handleEnable() {
      let self = this;
      let getSelections = this.$refs.onlineServiceTableRef.getSelections()
      if (getSelections.length > 0) {
        let sysCorpCustIds = []
        getSelections.forEach(el => {
          sysCorpCustIds.push(el.sysCorpCustId)
        })
        onWebService({ sysCorpCustIds }).then(res => {
          if (res.success) {
            self.handleQuery()
            self.$coreMethods.message('success', '启用成功！')
          } else {
            self.$coreMethods.message('error', '启用失败！')
          }
        })
      } else {
        self.$coreMethods.message('error', '请勾选数据！')
      }
    },
    // 禁用
    handleDisable() {
      let self = this;
      let getSelections = this.$refs.onlineServiceTableRef.getSelections()
      if (getSelections.length > 0) {
        let sysCorpCustIds = []
        getSelections.forEach(el => {
          sysCorpCustIds.push(el.sysCorpCustId)
        })
        OffWebService({ sysCorpCustIds }).then(res => {
          if (res.success) {
            self.handleQuery()
            self.$coreMethods.message('success', '禁用成功！')
          } else {
            self.$coreMethods.message('error', '禁用失败！')
          }
        })
      } else {
        self.$coreMethods.message('error', '请勾选数据！')
      }
    },
    // 删除
    handleDel() {
      let isAllActive = false;
      let self = this;
      let getSelections = this.$refs.onlineServiceTableRef.getSelections()
      if (getSelections.length > 0) {
        let sysCorpCustIds = []
        getSelections.forEach(el => {
          if (el.isActive === 1) isAllActive = true;
          sysCorpCustIds.push(el.sysCorpCustId)
        })
        if (isAllActive) return self.$coreMethods.message('warning', '请勾选失效的记录')
        deleteWebService({ sysCorpCustIds }).then(res => {
          if (res.success) {
            self.handleQuery()
            self.$coreMethods.message('success', '删除成功！')
          } else {
            self.$coreMethods.message('error', '删除失败！')
          }
        })
      } else {
        self.$coreMethods.message('error', '请勾选数据！')
      }
    },
    // 查询
    handleQuery() {
      let self = this
      self.onlineServiceForm.currentPage = self.pageConfig.currentPage
      self.onlineServiceForm.pageSize = self.pageConfig.pageSize
      getSysCorpCustDataSource(self.onlineServiceForm).then(res => {
        if (res.success) {
          self.onlineServiceTableDataSource = res.records
          self.pageConfig.total = res.total
          self.$forceUpdate()
        } else {
          self.$coreMethods.message('error', '查询失败！')
        }
      })
    },
    // 查询
    handleQueryDialog() {

      let self = this;

      if(!self.openOnlineServiceDialogForm.sysCorpId){
        self.$coreMethods.message("error", "结算公司不能为空！");
        return;
      }

      let params = {};
      let num = 0;
      for (let s in self.openOnlineServiceDialogForm) {
        if (self.openOnlineServiceDialogForm[s] !== "") {
          num++;
        }
      }
      if (num === 0) {
        params = {
          custType4: "%CM%",
          custType5: "%OA%",
          isDeleted6: "0",
        };
      } else {
        params = {
          custAlias0: "%" + self.openOnlineServiceDialogForm.data + "%",
          custNameCn1: "%" + self.openOnlineServiceDialogForm.data + "%",
          custType4: "%CM%",
          custType5: "%OA%",
          isDeleted6: "0",
          sysCorpId7: self.openOnlineServiceDialogForm.sysCorpId,
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPVwCsCust.custNameCn"],
        mainModelName: "CTS_ILPVwCsCust",
        tag: "CTS_WEB_es",
        where:
            "(((((CTS_ILPVwCsCust.custAlias LIKE :custAlias0 OR CTS_ILPVwCsCust.custNameCn LIKE :custNameCn1) ) AND (CTS_ILPVwCsCust.custType LIKE :custType4 OR CTS_ILPVwCsCust.custType LIKE :custType5)) ) AND CTS_ILPVwCsCust.isDeleted = :isDeleted6   AND CTS_ILPVwCsCust.settleOffice = :sysCorpId7)\n",
        currentPage: self.pageConfigDialog.currentPage,
        pageSize: self.pageConfigDialog.pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPVwCsCust.csCustId",
          "CTS_ILPVwCsCust.custAlias",
          "CTS_ILPVwCsCust.custNameCn",
          "CTS_ILPVwCsCust.custNameEn",
          "CTS_ILPVwCsCust.custType",
          "CTS_ILPVwCsCust.isActive",
          "CTS_ILPVwCsCust.isBlacklist",
          "CTS_ILPVwCsCust.isCustomer",
          "CTS_ILPVwCsCust.isDeleted",
          "CTS_ILPVwCsCust.isOneTimeCustomer",
          "CTS_ILPVwCsCust.isSettlement",
          "CTS_ILPVwCsCust.isSupplier",
          "CTS_ILPVwCsCust.mdmCustCode",
          "CTS_ILPVwCsCust.postCode"
        ],
        enableCascade: true,
      };
      queryVwCsCustInfo(data).then((res) => {
        if (res.success) {
          self.onlineServiceDialogTableDataSource = res.data.data;
          self.pageConfigDialog.total = res.data.totalRecord;
          self.$forceUpdate()
        } else {
          self.$coreMethods.message('error', '查询失败！')
        }
      });
    },
    // 重置
    handleReset() {
      this.onlineServiceForm = {}
    },
    // 弹框启用
    handleEnableDialog() {
      let self = this;
      let getSelections = self.$refs.onlineServiceDialogTableRef.getSelections()
      if (getSelections.length === 1) {
        self.adminAccountDialogForm.selections = self.$refs.onlineServiceDialogTableRef.getSelections();
        self.adminAccountDialogVisible = true;
        let data = {
          csCustId: self.adminAccountDialogForm.selections[0].csCustId,
        };
        this.adminAccountDialogForm.corpNameCn=this.corpNameCn;
        this.adminAccountDialogForm.sysCorpId=this.sysCorpId;
        this.adminAccountDialogForm.corpNameEn=this.corpNameEn;
        getCsCustType(data).then((res) => {
          if(res.success){
            let result = res.records;
            if(result.length > 0){
              if(result.includes("OA") && result.includes("CM")){
                self.roleEditabled = false;
              }else if(result.includes("OA")){
                self.roleEditabled = true;
                self.adminAccountDialogForm.sysRoleIds = [];
                this.adminAccountDialogForm.roleNames = [];
                this.adminAccountDialogForm.sysRoleIdAndNames = [];
                self.adminAccountDialogForm.roleNames.push("海外代理系统管理员");
                self.adminAccountDialogForm.sysRoleIds.push("6913106226243182592");
                let role = {
                  roleName: "海外代理系统管理员",
                  sysRoleId: "6913106226243182592"
                }
                this.adminAccountDialogForm.sysRoleIdAndNames.push(role)
              }else if(result.includes("CM")){
                self.roleEditabled = true;
                self.adminAccountDialogForm.sysRoleIds = [];
                this.adminAccountDialogForm.roleNames = [];
                this.adminAccountDialogForm.sysRoleIdAndNames = [];
                self.adminAccountDialogForm.roleNames.push("客户系统管理员");
                self.adminAccountDialogForm.sysRoleIds.push("6913097993487130624");
                let role = {
                  roleName: "客户系统管理员",
                  sysRoleId: "6913097993487130624"
                }
                this.adminAccountDialogForm.sysRoleIdAndNames.push(role)
              }
            }else {
              self.$coreMethods.message('error', '当前客商的用户属性为空，无法开启')
            }
          }
        })
      } else if (getSelections.length > 0) {
        self.$coreMethods.message('error', '只允许勾选一条数据！')
      } else {
        self.$coreMethods.message('error', '请勾选数据！')
      }
    },
    handleResetDialog() {
      this.openOnlineServiceDialogForm = {}
    },
    // pageSize 改变时会触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pageConfig.pageSize = val
      this.handleQuery()
    },
    // currentPage 改变时会触发
    handleCurrentChange(val) {
      this.pageConfig.currentPage = val
      this.handleQuery()
    },
    // pageSize 改变时会触发
    handleSizeChangeDialog(val) {
      this.pageConfigDialog.pageSize = val
      this.handleQueryDialog()
    },
    // currentPage 改变时会触发
    handleCurrentChangeDialog(val) {
      this.pageConfigDialog.currentPage = val
      this.handleQueryDialog()
    },
     corpNameCnChange(value,selectedRows) {
          this.openOnlineServiceDialogForm.corpNameCn=selectedRows.corpNameCn;
          this.openOnlineServiceDialogForm.sysCorpId=selectedRows.sysCorpId;
          if(selectedRows.sysCorpId){ //若有值,则取消必填校验提示
              this.onlineServiceRules.corpNameCn[0].required=false;
              this.corpNameCn=selectedRows.corpNameCn;
              this.corpNameEn=selectedRows.corpNameEn;
              this.sysCorpId=selectedRows.sysCorpId;
          }else{
              this.onlineServiceRules.corpNameCn[0].required=true;
          }
        },
    // 取消
    handleCancel() {
      this.openOnlineServiceDialogVisible = false;
    },
    adminAccountDialogConfirm() {

      let self = this;
      let adminAccountData = {};
      let csCusts = [];
      this.isOpenService = true;
      this.adminAccountDialogForm.selections.forEach(el => {
        el.rowStatus = 4
        csCusts.push(el)
      })
      adminAccountData.csCust = csCusts[0];
      if(this.adminAccountDialogForm && this.adminAccountDialogForm.corpNameCn ==null ){
        self.$coreMethods.message('error', '结算公司不允许为空！')
        return;
      }
      if(this.adminAccountDialogForm && this.adminAccountDialogForm.roleNames.length === 0){
        self.$coreMethods.message('error', '角色不允许为空！')
        return;
      }

      adminAccountData.sysRoleIdAndNames = this.adminAccountDialogForm.sysRoleIdAndNames
      adminAccountData.roleNames = this.adminAccountDialogForm.roleNames
      adminAccountData.sysCorpId = this.adminAccountDialogForm.sysCorpId
      adminAccountData.corpNameCn = this.adminAccountDialogForm.corpNameCn
      adminAccountData.corpNameEn = this.adminAccountDialogForm.corpNameEn
      if(this.adminAccountDialogForm && this.adminAccountDialogForm.end !=null){
        adminAccountData.userCode = this.adminAccountDialogForm.start + this.adminAccountDialogForm.end;
      }
      if(this.adminAccountDialogForm.roleNames.includes("海外代理系统管理员")){
        adminAccountData.userType = "13";
      }else{
        adminAccountData.userType = "2";
      }
      var userName=this.adminAccountDialogForm.start+ this.adminAccountDialogForm.end;
            let data = {
              userName:userName
            }
        checkSysUserName(data).then((res) => {
                  if (res.success) {
                    var u=document.getElementById("userName");
                       if(res.result){
                        u.style.borderColor="#F56C6C";
                        self.$coreMethods.message('error', '该管理员账号已存在,无法保存！')
                        this.isOpenService = false;
                       }else{
                          u.style.borderColor="#DCDFE6";
                            startWebService(adminAccountData).then(res => {
                                   if (res.success) {
                                     self.handleQuery();
                                     self.adminAccountDialogForm.end = null;
                                     self.$coreMethods.message('success', '启用成功！')
                                     this.adminAccountDialogForm.roleNames = [];
                                     this.adminAccountDialogForm.sysRoleIdAndNames = [];
                                     self.openOnlineServiceDialogVisible = false;
                                     self.adminAccountDialogVisible = false;
                                     this.isOpenService = false;
                                   } else {
                                     self.$coreMethods.message('error', '启用失败！')
                                     this.adminAccountDialogForm.roleNames = [];
                                     this.adminAccountDialogForm.sysRoleIdAndNames = [];
                                     this.isOpenService = false;
                                   }
                                 }).catch(res => {
                                   this.isOpenService = false;
                                 })
                       }
                   }
              });


    },

    onChangeUserName(value) {

          var userName="ADMIN_";
          var end=value.target.value;
          if(end){
            userName+=end;
            let self = this;
            let data = {
              userName:userName
            }

             checkSysUserName(data).then((res) => {
                 if (res.success) {
                   var u=document.getElementById("userName");
                      if(res.result){
                       u.style.borderColor="#F56C6C";
                       self.$coreMethods.message('error', '该登录账号已存在！')
                      }else{
                        u.style.borderColor="#DCDFE6";
                       }
                  }
             });
    }
        },
    onChangeSysCorp(value, selectedRows){
      this.adminAccountDialogForm.sysCorpId = selectedRows.sysCorpId;
      this.adminAccountDialogForm.corpNameEn = selectedRows.corpNameEn;
    },
    onChangeCorpName(value, selectedRows){
          this.onlineServiceForm.sysCorpId = selectedRows.sysCorpId;
          this.onlineServiceForm.corpNameEn = selectedRows.corpNameEn;
        },
    onChangeSysRole(value, selectedRows){
      console.log(selectedRows)
      this.adminAccountDialogForm.sysRoleIdAndNames = [];
      selectedRows.forEach(x => {
        let role = {
          roleName: x.roleName,
          sysRoleId: x.sysRoleId
        }
        this.adminAccountDialogForm.sysRoleIdAndNames.push(role)
      })
      console.log(this.adminAccountDialogForm.roleNames);
      console.log(this.adminAccountDialogForm.sysRoleIdAndNames);
    },
    cancelOpenService(){
      this.adminAccountDialogForm.roleNames = [];
      this.adminAccountDialogForm.sysRoleIdAndNames = [];
      this.adminAccountDialogVisible = false;
    }
  }
};
</script>

<style lang="scss">
.van-field__control {
  border: 1px solid #ccc !important
}
.redItem .el-form-item__label {
  text-align: left;
  width: 100%;
}
</style>
